const GA_MEASUREMENT_ID = "G-FPVFL9H3XW";

/** Loads gtag.js only in production (NODE_ENV from CRA build). */
export function initGtag() {
  if (process.env.NODE_ENV !== "production") return;

  const external = document.createElement("script");
  external.async = true;
  external.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(external);

  const inline = document.createElement("script");
  inline.textContent = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${GA_MEASUREMENT_ID}', {
  debug_mode: true
});
`;
  document.head.appendChild(inline);
}

/**
 * GA4 custom event (production only). Register parameter names as custom
 * dimensions in GA4 if you want them in standard reports.
 */
export function trackGtagEvent(eventName, params = {}) {
  if (typeof window === "undefined") return false;

  if (typeof window.gtag !== "function") {
    console.warn("[GA] gtag is not available. Event was not sent.", {
      eventName,
      params,
    });
    return false;
  }

  let callbackFired = false;
  const timeoutMs = 2000;

  window.gtag("event", eventName, {
    ...params,
    event_callback: () => {
      callbackFired = true;
      console.info("[GA] Event sent.", {
        eventName,
        params,
      });
    },
    event_timeout: timeoutMs,
  });

  window.setTimeout(() => {
    if (!callbackFired) {
      console.warn("[GA] Event dispatch did not confirm before timeout.", {
        eventName,
        params,
        timeoutMs,
      });
    }
  }, timeoutMs + 100);

  return true;
}
